import React from "react";
import classnames from "classnames";
import ContentLoader from "react-content-loader";
import styles from "./FormActionsLoader.module.scss";

const IasFormActionsLoader = ({ hide }) => {
  return (
    <div
      className={classnames(styles.FormActionsLoader, { [styles.hide]: hide })}
    >
      <ContentLoader
        speed={2}
        width={"40rem"}
        height={"2.375rem"}
        backgroundColor="#ecebeb"
        foregroundColor="#008fe2"
      >
        <rect x="0" y="0" rx="3" ry="3" width="9rem" height="2.375rem" />
        <rect x="11rem" y="0" rx="3" ry="3" width="9rem" height="2.375rem" />
      </ContentLoader>
    </div>
  );
};

export default IasFormActionsLoader;
